/** The page: boot screen until the kiosk is ready, then the canvas and, beside it, the open panel. */
import { useEffect, useMemo } from 'react';
import { readFlags } from '@platform/core/flags';
import { AppProvider } from '@platform/react/app';
import { Page } from '@platform/shell/Page';
import { applyViewportPolicy } from '@platform/shell/viewport-meta';
import { BootScreen } from './BootScreen';
import { useBoot } from './boot';

export function App() {
  const flags = useMemo(() => readFlags(window.location.search, { aec: import.meta.env.VITE_AEC_DEFAULT }), []);
  useEffect(() => applyViewportPolicy(flags.zoom), [flags.zoom]);
  const boot = useBoot(flags);
  if (boot.phase !== 'ready') return <BootScreen state={boot} />;
  return (
    <AppProvider app={boot.app}>
      <Page />
    </AppProvider>
  );
}
